export default "__VITE_ASSET__APTRruuX__"